import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-content flex-col items-center justify-center px-4 py-20 text-center md:px-6">
      <p className="font-label text-[92px] font-bold leading-none tracking-tight text-primary-700 md:text-[140px]">404</p>
      <h1 className="-mt-2 text-2xl font-bold text-foreground-50 md:text-3xl">这个页面不存在</h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-500">
        你要找的地址可能已经变更或被删除。当前路径：
        <span className="ml-1 break-all font-label text-xs text-foreground-400">{location.pathname}</span>
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/search"
          className="cursor-pointer whitespace-nowrap rounded-md border border-background-700 px-5 py-2.5 text-sm text-foreground-300 transition-colors hover:border-accent-500 hover:text-accent-400"
        >
          搜索影片
        </Link>
        <Link
          to="/news"
          className="cursor-pointer whitespace-nowrap rounded-md border border-background-700 px-5 py-2.5 text-sm text-foreground-300 transition-colors hover:border-accent-500 hover:text-accent-400"
        >
          浏览资讯
        </Link>
      </div>
    </div>
  );
}